module.exports = __webpack_public_path__ + "static/media/tictactoe.92a0f0e9.png";